import { Duration } from "luxon";

export function setAdsAttributionCookie({
  name,
  value,
  maxAgeDays,
}: {
  name: string;
  value: string;
  maxAgeDays: number;
}) {
  try {
    const secureAttribute = window.location.protocol === "https:" ? "; Secure" : "";
    const maxAgeSeconds = Math.floor(Duration.fromObject({ days: maxAgeDays }).as("seconds"));
    document.cookie = `${name}=${encodeURIComponent(value)}; Path=/; Max-Age=${maxAgeSeconds}; SameSite=Lax${secureAttribute}`;
  } catch {
    // Attribution storage failures must not block account creation.
  }
}

export function clearAdsAttributionCookie(name: string) {
  try {
    const secureAttribute = window.location.protocol === "https:" ? "; Secure" : "";
    document.cookie = `${name}=; Path=/; Max-Age=0; SameSite=Lax${secureAttribute}`;
  } catch {
    // Consent revocation must not fail when cookie storage is unavailable.
  }
}

export function getAdsAttributionCookie(name: string): string | undefined {
  try {
    const prefix = `${name}=`;
    const cookie = document.cookie
      .split(";")
      .map((part) => part.trim())
      .find((part) => part.startsWith(prefix));
    if (!cookie) return undefined;
    return decodeURIComponent(cookie.slice(prefix.length));
  } catch {
    return undefined;
  }
}
